import * as types from './action-types';
import YellowfinAPI from '../../api/YellowfinApi';

export const fetchYellowfinSSO = params => ({
  type: types.FETCH_YELLOWFIN_SSO_TOKEN,
  payload: YellowfinAPI.GetYellowfinSSO(params),
});



// WEBPACK FOOTER //
// ./src/features/yellowfin/actions.js